module.exports = __webpack_public_path__ + "img/emi_logo.372a1a33.png";